// extracted by mini-css-extract-plugin
export default {"card":"simulation_card__wrVg6","cardImage":"simulation_cardImage__XPgiH","cardContent":"simulation_cardContent__muSRZ","cardButton":"simulation_cardButton__-xKcB"};